module.exports = __webpack_public_path__ + "img/derive-pdf.e0bc5f1e.svg";